import React, { useContext, useEffect, useState } from "react";
import Courses from "../Templates/Home/Courses/Courses";
import useFetch from "../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { courseURL, listSchoolsURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";

function CoursesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);

  const [courses, setCourses] = useState([]);
  const { data, loading, error } = useFetch(
    courseURL,
    page,
    rowsPerPage,
    search
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setCourses(data.data);
      setPageCount(data.pagesCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Courses
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      courses={courses}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setCourses={setCourses}
    />
  );
}

export default CoursesPage;
